// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"315":"df511642","372":"95287393","374":"95287393","816":"df511642","974":"df511642"}[chunkId] + ".chunk.css";
};